// extracted by mini-css-extract-plugin
module.exports = {"product-card-border":"product-card-wrapper_product-card-border__Zsw4O","product-card-details":"product-card-wrapper_product-card-details__QzH1Y"};